// extracted by mini-css-extract-plugin
export default {"modalContent":"CannotDeactivateClientModal_modalContent__WPjoN"};